import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[filterActive]',
    standalone: false
})
export class FilterActiveDirective implements OnChanges {
  @Input() filterActive: boolean;

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterActive']) {
      this.filterActive ? this._attachActive() : this._detachActive();
    }
  }

  private _attachActive() {
    if (this.hasParent()) {
      return;
    }

    const {element, blockId} = this.findElementAndBlockId();
    this.renderer.addClass(element, `${blockId}__active`);
  }

  private _detachActive() {
    const {element, blockId} = this.findElementAndBlockId();
    this.renderer.removeClass(element, `${blockId}__active`);
  }

  private hasParent(): boolean {
    const parentNode = this.el.nativeElement.parentNode;
    if (!parentNode) {
      return;
    }
  }

  private findElementAndBlockId() {
    let doLoop = true;
    let element = this.el.nativeElement;
    let blockId;
    while (doLoop && element) {
      blockId = element.getAttribute('data-c-id');
      if (blockId) {
        doLoop = false;
      } else {
        element = element.parentNode;
      }
    }
    return {element, blockId};
  }
}
